import React, { Fragment, useContext, useEffect, useState } from 'react'
import { MdArrowDropDown } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import CardWithCard from '../../components/Cards/CardWithCard';
import Button from '../../components/Button/Button';
import axiosInstance from '../../services/api/axiosInstance';
import employerContext from '../../hooks/employerContext';
import { IoIosInformationCircleOutline } from "react-icons/io";
import Image from "../../utils/images";
import Joyride, { STATUS } from 'react-joyride';
import Cookie from 'js-cookie'
import Modal from 'react-bootstrap/Modal';
import Cookies from 'js-cookie';


const EmployerHome = () => {
  const { handleGetJobApi,
    setShowProgressBar,
    setShowFieldOne,
    setShowFieldTwo,
    setShowFieldThree,
    setShowFieldFour,
    setPageTwoJobDetails,
    setPageThreeJobDetails,
    setPageFourJobDetails,
    setProgressBarHide,
    setEditingJobFromHome,
    settxtDurations,
    setSpecificSpecialization,
    // Joyride
    employerProfileDropdown,
    employerApplicants,
    employerPool,
    subscriptionExpiredShow,

    // Pricing
    country,

    // Trial plan expired state
    get_payment_status,
    updateCheckoutStatus
  } = useContext(employerContext);

  const [temporaryModal, setTemporaryModal] = useState(false);

  useEffect(() => {
    handleGetJobApi('getPreviousJobTemplates');
    setPageTwoJobDetails({
      jobTitle: "",
      jobOverview: "",
      workplaceType: "Select",
      // location: "Select",
      jobType: "Select",
      timeCommitment: "Select",
      timeZone: "Select",
      schedule: "Select",
      duration: "Select",
      compensation: ""
    });

    setPageThreeJobDetails({
      jobDescription: null,
      skills: [],
      specialization: ""
    })
    setSpecificSpecialization("")

    setPageFourJobDetails({
      resume: "",
      coverLetter: "",
      bgCheck: "",
      hiring: "",
      questions: [],
      receive_notification: "Y"
    })

    settxtDurations({
      count: 0,
      format: 'Select'
    })

    updateCheckoutStatus()
  }, [])

  const [closingCandidateDetails, setClosingCandidateDetails] = useState([])

  // Card repetition array for temporary
  const count = ['1', '2', '3', '4', '5', '6']
  const pageRender = useNavigate();

  const [twoHundredResponse, setTwoHundredResponse] = useState('')
  const [assignJobModel, setAssignJobModel] = useState(false)
  const [assignJobModelData, setAssignJobModelData] = useState({})
  const [assignJobModelEditData, setAssignJobModelEditData] = useState({})
  const [assignJobValidation, setAssignJobValidation] = useState(false)
  const [jobAssignSpinner, setJobAssignSpinner] = useState(false)
  const [basicPlan_message, setBasicPlan_message] = useState(null)

  // state for api loading
  const [cardWithCardLoading, setCardWithCardLoading] = useState(true)

  // state for functionality
  const [sortByValue, setSortByValue] = useState('default')
  const [openValue, setOpenValue] = useState('opened')

  //  search filter
  const [searchJob, setSearchJob] = useState("")

  const handleOpenDropDown = (drop) => {
    setOpenValue(drop);
  }

  // state for api
  const [employerCardDetails, setEmployerCardDetails] = useState([]);
  const [employerCardDetailsDuplicate, setEmployerCardDetailsDuplicate] = useState([]);

  // Api handling with button click
  const handlePauseJobApi = (e, cardJobId, cardJobStatus) => {
    postEmployerJobPauseDetails(cardJobId, cardJobStatus)

  }

  const handleJobDelete = (e, cardJobId) => {
    postEmployerJobDelete(cardJobId)
  }

  const handleCloseJobApi = (e, radioValue, candidateName, candidateFeedback, cardJobId) => {
    postEmployerJobCloseDetails(cardJobId, radioValue, candidateName, candidateFeedback)
  }

  const handleOpenPauseJobApi = (e, cardJobId, cardJobStatus) => {
    postOpenPausedJob(cardJobId, cardJobStatus)
  }
  // =================================Double Button States======================================================================================

  const [appliedCandidates, setAppliedCandidates] = useState()


  const [candidateDetailsDb, setCandidateDetailsDb] = useState(true);


  const [radioValueDb, setRadioValueDb] = useState('Y')

  const [candidateFeedbackDb, setCandidateFeedbackDb] = useState('')

  const [postLeft, setPostLeft] = useState(0);
  const [totalPostLeft, setTotalPostLeft] = useState(0);
  const [costPerJob, setCostPerJob] = useState(0);
  const [costToExtend, setCostToExtend] = useState(0);
  const [subscribePlanModel, setSubscribePlanModel] = useState(false);
  const [user_plan, set_user_plan] = useState('')


  const handleCandidateSearchRadioButton = (e, cardJobId) => {
    if (e.target.value === 'Y') {
      setCandidateDetailsDb(true)
      setRadioValueDb('Y')
    }
    else {
      setCandidateDetailsDb(false)
      setRadioValueDb('N')
    }
    setCandidateFeedbackDb('')
    // setRadioValueDb('Y')
  }

  const handleCandidateFeedbackDb = (e) => {
    setCandidateFeedbackDb(e.target.value)
  }

  // ===================================================================================================================
  // Api hitting
  // Employer Home Open,Close,Pause
  const getEmployerHomePageDetails = async () => {
    setCardWithCardLoading(false)
    const homeParams = {
      "job_status": openValue
    }
    try {
      const response = await axiosInstance.post("/get_home_dashboard", homeParams)
      setCardWithCardLoading(true)

      if (response.data.error_code === 0 || response.data.error_code === 200) {
        // joy ride
        if (response.data.error_code === 200) {
          setTwoHundredResponse('200')
          Cookie.set("isEmployerFirstVisit", true)
          Cookie.set("isEmployerPoolFirstVisit", true)
        }

        setEmployerCardDetails(response.data.data[0].job_list)
        setEmployerCardDetailsDuplicate(response.data.data[0].job_list)
        setPostLeft(response.data.data[1].jobs_left > 0 ? response.data.data[1].jobs_left : 0)
        setCostPerJob(response.data.data[2].cost_per_job)
        setCostToExtend(response.data.data[3].cost_to_extend)
        setTotalPostLeft(response.data.data[4].total_jobs)
        set_user_plan(response.data.data[5].user_plan)
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getEmployerHomePageDetails()
    setSortByValue('default')
  }, [openValue])

  // applied candidates search
  const getAppliedCandidateSearch = async (cardJobId) => {
    const appliedCloseJobParams = {
      "job_id": cardJobId
    }
    try {

      const response = await axiosInstance.post("/get_applied_close_job", appliedCloseJobParams)
      if (response.data.error_code === 0) {
        setAppliedCandidates(response.data.data)
      }
    }
    catch (catchError) {
      console.log(catchError)
    }
  }

  // Job Close
  const postEmployerJobCloseDetails = async (cardJobId, radioValue, candidateName, candidateFeedback) => {
    if (radioValue === "N") {
      var closeJobParams = {
        "is_role_filled": radioValue,
        "candidate_id": '',
        "feedback": candidateFeedback,
        "job_id": cardJobId
      }
      var hitApi = true
    } else {
      if (closingCandidateDetails.length > 0) {
        var candidatesIds = closingCandidateDetails.map((v) => {
          return v.value
        })
        var closeJobParams = {
          "is_role_filled": radioValue,
          "candidate_id": candidatesIds,
          "feedback": candidateFeedback,
          "job_id": cardJobId
        }

        var hitApi = true
      } else {
        var hitApi = false
      }
    }
    if (radioValue == 'N') {
      if (candidateFeedback !== '') {
        try {
          const response = await axiosInstance.post("/close_job", closeJobParams)
          if (response.data.error_code === 0) {
            document.getElementById(`closeModal-${cardJobId}`).click()
            setCandidateFeedbackDb('')
            setTimeout(() => {
              getEmployerHomePageDetails()
            }, 2000)
          }
        }
        catch (catchError) {
          console.log(catchError)
        }
      } else {
        toast("Please fill the details", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
      }
    }
    else {
      if (hitApi && candidateFeedback !== '') {
        try {
          const response = await axiosInstance.post("/close_job", closeJobParams)
          if (response.data.error_code === 0) {
            document.getElementById(`closeModal-${cardJobId}`).click()
            setCandidateFeedbackDb('')
            setTimeout(() => {
              getEmployerHomePageDetails()
            }, 2000)
          }
        }
        catch (catchError) {
          console.log(catchError)
        }
      } else {
        toast("Please fill all the details", {
          icon: (
            <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
          ),
        });
      }
    }
  }

  // Job Pause
  const postEmployerJobPauseDetails = async (cardJobId, cardJobStatus) => {
    cardJobStatus === 'paused' ? cardJobStatus = 'opened' : cardJobStatus = 'paused';
    const pauseJobParams = {
      "job_id": cardJobId,
      "job_status": cardJobStatus
    }
    try {
      const response = await axiosInstance.post("/update_status_job_post", pauseJobParams)

      if (response.data.error_code === 0) {
        setTimeout(() => {
          getEmployerHomePageDetails()
        }, 2000)
      }
    }
    catch (catchError) {
      console.log(catchError)
    }
  }

  // Job Delete
  const postEmployerJobDelete = async (cardJobId) => {
    const deleteJobParams = {
      "job_id": cardJobId
    }

    try {
      const response = await axiosInstance.post("/delete_job_post", deleteJobParams)

      if (response.data.error_code === 0) {
        setTimeout(() => {
          getEmployerHomePageDetails()
        }, 2000)
      }
    }
    catch (catchError) {
      console.log(catchError)
    }
  }

  // Open paused Job
  const postOpenPausedJob = async (cardJobId, cardJobStatus) => {
    cardJobStatus === 'opened' ? cardJobStatus = 'paused' : cardJobStatus = 'opened';
    const openPausedJobParams = {
      "job_id": cardJobId,
      "job_status": cardJobStatus,
    }
    try {
      const response = await axiosInstance.post("/update_status_job_post", openPausedJobParams)

      if (response.data.error_code === 0) {
        setTimeout(() => {
          getEmployerHomePageDetails()
        }, 2000)
      }
    }
    catch (catchError) {
      console.log(catchError)
    }
  }

  const [jobCount, setJobCount] = useState("")


  function dynamicAdditionalPostKey() {
    switch (user_plan) {
      case "Basic":
        switch (country) {
          case "India":
            return process.env.REACT_APP_EMPLOYER_ADDITIONALJOB_BASIC_INR

          default:
            return process.env.REACT_APP_EMPLOYER_ADDITIONALJOB_BASIC_US
        }

      case "Premium":
        switch (country) {
          case "India":
            return process.env.REACT_APP_EMPLOYER_ADDITIONALJOB_PREMIUM_INR

          default:
            return process.env.REACT_APP_EMPLOYER_ADDITIONALJOB_PREMIUM_US
        }

      default:
        break;
    }
  }

  // Additional Job Post 
  const additionalJobPost = async (e, jobCount) => {
    let additionalJobPostParams;

    if (jobCount > 0 && jobCount !== "") {
      additionalJobPostParams = {
        lookup_key: dynamicAdditionalPostKey(),
        no_of_jobs: jobCount,
        is_date_extend: 0,
        product: "Additional_Job",
        job_id: "",
        user: "Employer"
      }

      try {
        const response = await axiosInstance.post("/create_payment_session", additionalJobPostParams)

        if (response.data.error_code === 0) {
          window.location.href = response.data.data.url;
          setJobCount("")
          document.getElementById("additionalJobPostCloseButton").click()
        } else {
          toast.error(response.data.message);
        }
      }
      catch (catchError) {
        console.log(catchError)
      }
    }
    else {
      toast("Please ensure the field is filled out correctly", {
        icon: (
          <IoIosInformationCircleOutline className="fs-2 brand-color me-1" />
        ),
      });
    }
  }

  // Extend Validity Post 
  const extendValidityPost = async (e, jobId, modalCloseId) => {
    let extendValidityPostParams;

    if (country === "India") {
      extendValidityPostParams = {
        lookup_key: process.env.REACT_APP_INDIAN_PRICE_EXTENDJOB,
        no_of_jobs: 1,
        is_date_extend: 1,
        product: "Extend_Job",
        job_id: jobId,
        user: "Employer"
      }
    }
    else {
      extendValidityPostParams = {
        lookup_key: process.env.REACT_APP_US_PRICE_EXTENDJOB,
        no_of_jobs: 1,
        is_date_extend: 1,
        product: "Extend_Job",
        job_id: jobId,
        user: "Employer"
      }

    }
    try {

      const response = await axiosInstance.post("/create_payment_session", extendValidityPostParams)

      if (response.data.error_code === 0) {
        window.location.href = response.data.data.url;
        document.getElementById(modalCloseId).click()
      } else {
        toast.error(response.data.message);
      }
    }
    catch (catchError) {
      console.log(catchError)
    }
  }

  // Sorting with dateposted, a-z , z-a
  const handleSortByDropDown = (sortValue) => {
    setSortByValue(sortValue)

    if (employerCardDetails.length > 0) {
      switch (sortValue) {
        case "Date Posted":
          setSortByValue("Date Posted")
          var sorting = employerCardDetails.sort(function (a, b) {

            let d1 = new Date(a.posted_on),
              d2 = new Date(b.posted_on)
            if (d1 > d2) {
              return -1;
            }
          })
          setEmployerCardDetailsDuplicate(sorting)

          break;

        case "A - Z":
          setSortByValue("A - Z")
          var sorting = employerCardDetails.sort(function (a, b) {
            if (a.job_title.toLowerCase() < b.job_title.toLowerCase()) {
              return -1;
            }
          })
          setEmployerCardDetailsDuplicate(sorting)

          break;

        case "Z - A":
          setSortByValue("Z - A")
          var sorting = employerCardDetails.sort(function (a, b) {
            if (b.job_title.toLowerCase() < a.job_title.toLowerCase()) {
              return -1;
            }
          })
          setEmployerCardDetailsDuplicate(sorting)

          break;
        default:
          break;
      }
    }

  }

  // handle Search
  const handleSearchJob = (e) => {
    setSearchJob(e.target.value)
    var searchResults = employerCardDetails.filter((employee) => {
      return employee.job_title.toLowerCase().includes(e.target.value.toLowerCase().trim())
    })
    setEmployerCardDetailsDuplicate(searchResults)
  }

  const handlePostJobButton = () => {
    setPageTwoJobDetails({
      jobTitle: "",
      jobOverview: "",
      workplaceType: "Select",
      jobType: "Select",
      timeCommitment: "Select",
      timeZone: "Select",
      schedule: "Select",
      duration: "Select",
      compensation: ""
    });

    setPageThreeJobDetails({
      jobDescription: null,
      skills: [],
      specialization: ""
    })
    setSpecificSpecialization("")

    setPageFourJobDetails({
      resume: "",
      coverLetter: "",
      bgCheck: "",
      hiring: "",
      questions: [],
      receive_notification: "Y"
    })

    settxtDurations({
      count: 0,
      format: 'Select'
    })

    setShowFieldOne(true);
    setShowFieldTwo(false);
    setShowFieldThree(false);
    setShowFieldFour(false);
    setShowProgressBar(true)
    setProgressBarHide(false)
    setEditingJobFromHome(false)
    pageRender("/employer_dashboard/multistepForm")
  }

  // JOYRIDE
  const steps = [
    {
      target: 'body',
      content: <div className="text-center">
        <h4 className='fw-bold mb-4'>Welcome to 2nd Careers</h4>
        <p>Manage your job postings, view applicants, and connect with experienced professionals.</p>
      </div>,
      placement: "center"
    },
    {
      target: '#postJobButton',
      content: 'Click here to post a new job opportunity and start discovering your ideal candidates.',
      placement: "top"
    },
    {
      target: `#${employerProfileDropdown}`,
      content: 'Manage your company profile and showcase important information about your organization.',
      placement: "top"
    },
    {
      target: `#${employerApplicants}`,
      content: 'View applicants for your job and review their applications.',
      placement: "top"
    },
    {
      target: `#${employerPool}`,
      content: 'Explore professionals on the 2nd Careers platform seeking opportunities.',
      placement: "top"
    },
  ];

  const [run, setRun] = useState(false);

  useEffect(() => {
    setRun(true);
    setTemporaryModal(Cookie.get('temporary_modal') ? Cookie.get('temporary_modal') : false)
  }, []);

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if ([STATUS.SKIPPED, STATUS.FINISHED].includes(status)) {
      Cookie.remove("isEmployerFirstVisit");
    }
  };

  const handlePremiumPlan = () => {
    document.getElementById("additionalJobPostCloseButton").click()
    pageRender("/employer_dashboard/pricing-plan")
  }

  function dynamicPostJobButton(id, model_target, model_click_fun) {
    return <Button
      id={id}
      className='btn btn-brand-color postButtonTextSize fw-bold buttonMarginBottom'
      data_bs_toggle={model_target ? "modal" : null}
      data_bs_target={model_target}
      title="&#43; Post&nbsp;a&nbsp;job"
      functionOnchange={model_click_fun}
    />
  }

  const handleTrialPlanExpireAndJobCountZero = () => {
    switch (Cookie.get("pricing_category")) {
      case "beta":
        var modal_msg = "Please upgrade your plan to continue posting new jobs.";
        return dynamicPostJobButton("emloyerPostAJobButton", "", () => setSubscribePlanModel(true))

      // for basic plan user 
      case "Basic":
        switch (Cookie.get("payment_status")) {
          case "trialing":
            var modal_msg = "Please upgrade your plan to continue posting new jobs.";
            return dynamicPostJobButton("emloyerPostAJobButton", "", () => setSubscribePlanModel(true))

          case "paid":
          case "active":
            return postLeft <= 0 ?
              Cookie.get("user_role") === "recruiter" ?
                dynamicPostJobButton("emloyerPostAJobButton", "#additiona0lJobPostModal_Restrict_Recuriter")
                :
                dynamicPostJobButton("emloyerPostAJobButton", "#additionalJobPostModal")
              :
              dynamicPostJobButton("emloyerPostAJobButton", "", handlePostJobButton)

          case "cancelled":
          case "canceled":
          case "incomplete":
          case "unpaid":
            var modal_msg = "Please upgrade your plan to continue posting new jobs.";
            return dynamicPostJobButton("emloyerPostAJobButton", "#trialPlanExpiredModal", () => setBasicPlan_message(modal_msg))

          default:
            break;
        }

      // for premium plan user 
      case "Premium":
        switch (Cookie.get("payment_status")) {
          case "paid":
          case "active":
            return postLeft <= 0 ?
              Cookie.get("user_role") === "recruiter" ?
                dynamicPostJobButton("emloyerPostAJobButton", "#additiona0lJobPostModal_Restrict_Recuriter")
                :
                dynamicPostJobButton("emloyerPostAJobButton", "#additionalJobPostModal")
              :
              dynamicPostJobButton("emloyerPostAJobButton", "", handlePostJobButton)

          case "cancelled":
          case "canceled":
          case "incomplete":
          case "unpaid":
            var modal_msg = "Please upgrade your plan to continue posting new jobs.";
            return dynamicPostJobButton("emloyerPostAJobButton", "#trialPlanExpiredModal", () => setBasicPlan_message(modal_msg))

          default:
            break;
        }

      // for platinum plan user 
      case "Platinum":
        switch (Cookie.get("payment_status")) {
          case "paid":
          case "active":
            return postLeft <= 0 ?
              Cookie.get("user_role") === "recruiter" ?
                dynamicPostJobButton("emloyerPostAJobButton", "#additiona0lJobPostModal_Restrict_Recuriter")
                :
                dynamicPostJobButton("emloyerPostAJobButton", "#additionalJobPostModal")
              :
              dynamicPostJobButton("emloyerPostAJobButton", "", handlePostJobButton)


          case "cancelled":
          case "canceled":
          case "incomplete":
          case "unpaid":
            var modal_msg = "Please upgrade your plan to continue posting new jobs.";
            return dynamicPostJobButton("emloyerPostAJobButton", "#trialPlanExpiredModal", () => setBasicPlan_message(modal_msg))

          default:
            break;
        }

      default:
        break;
    }
  }

  const addtionalPostModal = () => {
    switch (country) {
      case "India":
        switch (user_plan) {
          case "Basic":
            return process.env.REACT_APP_ADDITIONAL_JOB_BASIC_RUPEES

          case "Premium":
            return process.env.REACT_APP_ADDITIONAL_JOB_PREMIUM_RUPEES

          default:
            break;
        }

      case "United States":
        switch (user_plan) {
          case "Basic":
            return "$" + process.env.REACT_APP_ADDITIONAL_JOB_BASIC_DOLLARS

          case "Premium":
            return "$" + process.env.REACT_APP_ADDITIONAL_JOB_PREMIUM_DOLLARS

          default:
            break;
        }

      default:
        break;
    }

  }

  const handleAssignJob = async () => {
    if (assignJobModelEditData?.sub_user_id && assignJobModelEditData?.confirmation) {
      setJobAssignSpinner(true)
      setAssignJobValidation(false)
      const params = {
        user_id: parseInt(assignJobModelEditData?.sub_user_id),
        job_status: openValue,
        job_id: parseInt(assignJobModelData?.job_id),
        employer_id: parseInt(assignJobModelData?.employer_id)
      }

      try {
        const { data } = await axiosInstance.post("/assign_jobs", params)

        if (data?.error_code === 0 || data?.error_code === 200) {
          setAssignJobModel(false)
          setJobAssignSpinner(false)
          getEmployerHomePageDetails()
        } else {
          setJobAssignSpinner(false)
        }
      } catch (Err) {
        setJobAssignSpinner(false)
      }
    } else {
      setAssignJobValidation(true)
    }
  }

  return (
    <>
      <div className="container-fluid community-page-bg h-100 employer-home-page pt-4 py-2">
        <div className="row row-cols-lg-2 row-cols-md-2 align-items-lg-center justify-content-lg-between align-items-md-center justify-content-md-evenly employerHomePadding">
          <div className="col-lg-5 col-sm-12 col-md-12 ">
            <div className="row align-items-lg-center justify-content-lg-between align-items-md-center justify-content-md-between">

              {cardWithCardLoading ?
                <div className='col-lg-7 col-sm-7 col-md-7'>
                  <div className="dropdown employer-custom-dropdown">
                    <button
                      id='employerSortByButton'
                      className="btn dropdown-toggle rounded py-2 w-100 buttonMarginBottom"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    ><span className='fw-semibold'>Sort by : </span><span>{sortByValue}</span></button>

                    <ul className="dropdown-menu employer-custom-dropdown border-0 shadow w-100">

                      <li id='employerDatePosted'><a className="dropdown-item fw-medium  ps-4" onClick={() => handleSortByDropDown('Date Posted')}>Date Posted</a></li>
                      <hr className='m-0 mx-4 buttonLineColor' />
                      <li id='employerAToZ'><a className="dropdown-item fw-medium  ps-4" onClick={() => handleSortByDropDown('A - Z')}>A - Z</a></li>
                      <hr className='m-0 mx-4 buttonLineColor' />
                      <li id='employerZToA'><a className="dropdown-item fw-medium  ps-4" onClick={() => handleSortByDropDown('Z - A')}>Z - A</a></li>
                    </ul>
                  </div>

                </div>
                :
                <div className='col-lg-7 col-sm-7 col-md-7 placeholder-glow'>
                  <h5 className="card-title">
                    <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                  </h5>
                </div>
              }

              {cardWithCardLoading ?
                <div className='col-lg-5 col-sm-5 col-md-5'>
                  <div className="dropdown employer-custom-dropdown w-100">
                    <button
                      id='employerStatus'
                      className="btn dropdown-toggle border-0 w-100 px-2 py-2 buttonMarginBottom
                      .6269+"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    ><span className='fw-semibold'>Status : </span><span>{openValue === 'opened' ? 'Open' : openValue === 'paused' ? 'Paused' : openValue === 'closed' ? 'Closed' : openValue}</span></button>

                    <ul className="dropdown-menu border-0 shadow w-100">
                      <li id='employerOpen'><a className="dropdown-item fw-medium ps-4" onClick={() => handleOpenDropDown('opened')}>Open </a></li>
                      <hr className='m-0 mx-4 buttonLineColor ' />
                      <li id='employerClosed'><a className="dropdown-item fw-medium  ps-4" onClick={() => handleOpenDropDown('closed')}>Closed </a></li>
                      <hr className='m-0 mx-4 buttonLineColor ' />
                      <li id='employerPaused'><a className="dropdown-item fw-medium ps-4" onClick={() => handleOpenDropDown('paused')}>Paused </a></li>
                    </ul>
                  </div>

                </div>
                :
                <div className='col-lg-5 col-sm-5 col-md-5 placeholder-glow'>
                  <h5 className="card-title ">
                    <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                  </h5>
                </div>
              }
            </div>
          </div>

          <div className="col-lg-7 col-md-12 col-sm-12">
            {cardWithCardLoading ?
              <div className="d-lg-flex align-items-lg-center justify-content-lg-between d-md-flex  d-sm-flex align-items-md-center justify-content-md-between justify-content-sm-between align-items-sm-center ">
                <div className="position-relative align-items-center searchJobSpace">
                  <input
                    id='employerSearchField'
                    type="text"
                    className="form-control shadow rounded px-5 search-field buttonMarginBottom"
                    placeholder="Search by job role"
                    onChange={(e) => handleSearchJob(e)}
                  />
                  <span className='fs-5 search-icon'><IoSearchOutline /></span>
                </div>
                <div className="post p-2"  >
                  <span className=' brand-color'>Remaining Posts : {postLeft}/{totalPostLeft}</span>
                </div>
                <div className='align-items-center' id='postJobButton'>
                  {
                    handleTrialPlanExpireAndJobCountZero()
                  }
                </div>
              </div>
              :
              <div className='row align-items-lg-center justify-content-lg-between align-items-md-center justify-content-md-between justify-content-sm-between align-items-sm-center placeholder-glow'>
                <div className='col-lg-6 col-sm-8 col-md-7'>
                  <h5 className="card-title ">
                    <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                  </h5>
                </div>
                <div className='col-lg-4 col-sm-4 col-md-5'>
                  <h5 className="card-title ">
                    <span className="placeholder col-9 py-3 rounded-3 buttonMarginBottom"></span>
                  </h5>
                </div>
              </div>
            }
          </div>
        </div>

        <hr className='mx-4 mx-sm-5' />

        <div className="eHome-body-page-height mt-4 overflow-scroll employerHomePadding employerHomeMediumPadding">
          <div className="col-lg-12 h-100">
            {cardWithCardLoading ?
              (
                <div className="container-fluid px-0">
                  <div className="d-flex flex-wrap">
                    {
                      employerCardDetailsDuplicate.length > 0 ?
                        employerCardDetailsDuplicate.map((employerCard, index) => {
                          return (
                            <div className="col-12 col-md-6 col-xl-4 p-2" key={index}>
                              <CardWithCard
                                cardKey={index}
                                jobId={employerCard.job_id}
                                cardTitle={employerCard.job_title}
                                cardDate={employerCard.posted_on}
                                viewed={employerCard.view_count}
                                applied={employerCard.applied_count}
                                notReviewed={employerCard.not_reviewed_count}
                                shortlisted={employerCard.shortlisted_count}
                                firstButton_Name="Open"
                                secondButton_Name="View"
                                firstCardColor="secondary"
                                secondCardColor="brand-color"
                                openValue={openValue}
                                icon={<MdArrowDropDown />}
                                dropDownName={openValue !== '' ? openValue : null}
                                handleCloseJob={handleCloseJobApi}
                                handlePauseJob={handlePauseJobApi}
                                handleOpenJob={handleOpenPauseJobApi}
                                searchJob={searchJob}
                                handleCandidateSearchRadioButton={handleCandidateSearchRadioButton}
                                remainingDays={employerCard.days_left}
                                costToExtend={costToExtend}
                                extendValidityPost={extendValidityPost}
                                // Double Button 
                                candidateDetailsDb={candidateDetailsDb}
                                setCandidateDetailsDb={setCandidateDetailsDb}
                                radioValueDb={radioValueDb}
                                setRadioValueDb={setRadioValueDb}
                                candidateFeedbackDb={candidateFeedbackDb}
                                setCandidateFeedbackDb={setCandidateFeedbackDb}
                                handleCandidateFeedbackDb={handleCandidateFeedbackDb}
                                appliedCandidates={appliedCandidates}
                                setAppliedCandidates={setAppliedCandidates}
                                setClosingCandidateDetails={setClosingCandidateDetails}
                                getAppliedCandidateSearch={getAppliedCandidateSearch}
                                // job delete
                                handleJobDelete={handleJobDelete}
                                setAssignJobModel={setAssignJobModel}
                                setAssignJobModelData={setAssignJobModelData}
                                cardData={employerCard}
                                assigned_user_name={employerCard?.assigned_user_name}
                                setAssignJobModelEditData={setAssignJobModelEditData}
                                setAssignJobValidation={setAssignJobValidation}
                                setJobAssignSpinner={setJobAssignSpinner}
                              />
                            </div>
                          )
                        })
                        :
                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 h-100'>
                          <div className='d-flex justify-content-center h-100'>
                            {twoHundredResponse !== '' ?
                              <div className="card text-center border-0 rounded-4 py-3">
                                <div className="card-body">
                                  <h4 className="card-title fw-semibold mb-4">Welcome to 2nd Careers!</h4>
                                  <p >Post your first job now to start connecting with top talent.</p>
                                  <p >Please take a moment to complete your company profile. This will help us tailor our services to your specific needs.</p>
                                </div>
                              </div>
                              :
                              <img src={Image.noRecordsFound} width={250} height={250} />
                            }
                          </div>
                        </div>
                    }
                  </div>
                </div>
              )
              :
              // Placeholder Loading
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-3 g-4 mb-4">
                {
                  count.map((c, i) => {
                    return (
                      <div className="col-12 col-md-6 col-lg-4" key={i}>
                        <div
                          className="card border-0 p-0 rounded-3 overflow-hidden placeholder-glow"
                          aria-hidden="true"
                          key={i}>
                          <div className="card-body p-0">
                            <div className="p-3 py-3">
                              <h5 className="card-title ">
                                <span className="placeholder col-9 py-3 rounded-3"></span>
                              </h5>
                              <p className="card-text">
                                <span className="placeholder col-5 py-3 rounded"></span>
                              </p>
                            </div>
                            <div className="col-12 px-4 pb-4">
                              <div className="row align-items-center">
                                <div className="col-6 pe-0">
                                  <h5 className="card-title "><span className="placeholder col-10 py-5 rounded-3"></span></h5>
                                </div>
                                <div className="col-6 pe-0">
                                  <h5 className="card-title "><span className="placeholder col-10 py-5 rounded-3"></span> </h5>
                                </div>
                                <div className="col-6 pe-0">
                                  <h5 className="card-title "><span className="placeholder col-10 py-5 rounded-3"></span></h5>
                                </div>
                                <div className="col-6 pe-0">
                                  <h5 className="card-title "><span className="placeholder col-10 py-5 rounded-3"></span> </h5>
                                </div>
                              </div>
                            </div>

                            <div className="card-footer d-flex justify-content-between">
                              <button className="btn btn-outline-secondary placeholder col-5"></button>
                              <button className="btn btn-outline-secondary placeholder col-5"></button>
                            </div>
                          </div>
                        </div>
                      </div>

                    )
                  })
                }
              </div>
            }
          </div>
        </div>

        {/* Additional Job post Modal */}
        <div className="modal fade" id="additionalJobPostModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog  modal-dialog-centered">
            <div className="modal-content py-2 px-3">
              <div className="modal-header border-0 bg-transparent">
                <h1 className="modal-title fs-5 fw-bold" id="staticBackdropLabel">Additional job post</h1>
                <button type="button" id='additionalJobPostCloseButton' className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setJobCount("")}></button>
              </div>
              {
                ["premium", "basic"].includes(user_plan?.toLowerCase()) ?
                  <hr className='m-0 mx-3' />
                  :
                  null
              }


              <div className="modal-body px-3 pt-4 pb-1 w-100">
                {
                  ["premium", "basic"].includes(user_plan?.toLowerCase()) ?
                    <Fragment>
                      <div className="col mb-3">Number of additional jobs that you wish to post</div>
                      <div className="col">
                        <input
                          className='form-control rounded'
                          type="number"
                          value={jobCount}
                          onChange={(e) => setJobCount(e.target.value)}
                          min={1}
                        />
                      </div>
                      <p className=' py-2 text-secondary jobPost-FontSize'>
                        Pricing for one job post :
                        <span className='brand-color'>
                          {addtionalPostModal()}
                        </span>
                      </p>

                      <div className='jobPost-FontSize text-secondary py-2'><IoIosInformationCircleOutline className='brand-color' /> Enhance your experience by upgrading to our Premium or Platinum plans <a className='icon-link cursorPointer' onClick={handlePremiumPlan}>click here !</a></div>
                    </Fragment>
                    :
                    <div className='py-3'>
                      <div className="col mb-3">If you need to purchase additional job posts, please contact us at
                        <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info@2ndcareers.com" target="_blank" className='px-2'>
                          info@2ndcareers.com
                        </a>
                        for assistance with job postings.</div>
                    </div>
                }

              </div>

              {
                ["premium", "basic"].includes(user_plan?.toLowerCase()) ?
                  <hr className='m-0 mx-3 text-dark' />
                  :
                  null
              }

              <div className="modal-footer border-0 my-3 bg-transparent row align-items-center justify-content-between ">
                {
                  ["premium", "basic"].includes(user_plan?.toLowerCase()) ?
                    <Fragment>
                      <div className={"m-0 col-6"}>
                        <button type="button" className="btn w-100 btn-outline-secondary fw-bold" data-bs-dismiss="modal" onClick={() => setJobCount("")}>Cancel</button>
                      </div>
                      <div className={"m-0 col-6"}>
                        <button type="button" className="btn w-100 btn-brand-color fw-bold" onClick={(e) => additionalJobPost(e, jobCount)}>Proceed</button>
                      </div>
                    </Fragment>
                    :
                    <div className={`m-0 col-12`}>
                      <button
                        type="button"
                        className="btn w-100 btn-brand-color fw-bold"
                        data-bs-dismiss="modal"
                        onClick={() => window.open("https://mail.google.com/mail/?view=cm&fs=1&to=info@2ndcareers.com", "_blank")}
                      >
                        Send email
                      </button>
                    </div>
                }

              </div>

            </div>
          </div>
        </div>

        {/* Trial plan expired redirection Modal */}
        <div className="modal fade" id="trialPlanExpiredModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog  modal-dialog-centered">

            <div className="modal-content pt-2 pb-4 px-3">
              <div className="modal-header bg-transparent border-0 pb-0">
                <button type="button" id='trialPlanExpiredCloseButton' className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div className="modal-header border-0 bg-transparent d-flex align-items-center justify-content-center">
                <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
              </div>

              <div className="modal-body px-3 pb-1 pt-0 w-100 text-center">
                <div className="col mb-3">{basicPlan_message}</div>
                <button className='text-center btn  signUpFree px-3 py-2 fw-bold btn-brand-color my-3' onClick={() => { document.getElementById("trialPlanExpiredCloseButton").click(); pageRender("/employer_dashboard/pricing-plan") }}>
                  Upgrade your plan
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* job post count Zero Modal */}
        <div className="modal fade" id="jobPostCountZeroModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog  modal-dialog-centered">

            <div className="modal-content pt-2 pb-4 px-3">
              <div className="modal-header bg-transparent border-0 pb-0">
                <button type="button" id='jobPostCountZeroCloseButton' className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div className="modal-header border-0 bg-transparent d-flex align-items-center justify-content-center">
                <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
              </div>

              <div className="modal-body px-3 pb-1 pt-0 w-100 text-center">
                <div className="col mb-3">{basicPlan_message}</div>
                <button className='text-center btn  signUpFree px-3 py-2 fw-bold btn-brand-color my-3' onClick={() => { document.getElementById("jobPostCountZeroCloseButton").click(); pageRender("/employer_dashboard/pricing-plan") }}>
                  Upgrade your plan
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* additiona0lJobPostModal_Restrict_Recuriter */}
        <div className="modal fade" id="additiona0lJobPostModal_Restrict_Recuriter" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog  modal-dialog-centered">

            <div className="modal-content pt-2 pb-4 px-3">
              <div className="modal-header bg-transparent border-0 pb-0">
                <button type="button" id='jobPostCountZeroCloseButton' className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div className="modal-header border-0 bg-transparent d-flex align-items-center justify-content-center">
                <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
              </div>

              <div className="modal-body px-3 pb-1 pt-0 w-100 text-center">
                <div className="col mb-3">Please contact your admin or owner to purchase an additional job.</div>
                <button className='text-center btn  signUpFree px-3 py-2 fw-bold btn-brand-color my-3 w-50' data-bs-dismiss="modal" aria-label="Close">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* subscribe when plan is in free tier  */}
        <Modal
          show={subscribePlanModel}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          contentClassName="rounded-4"
          onHide={() => setSubscribePlanModel(false)}
        >
          <Modal.Header closeButton className='border-0'></Modal.Header>
          <Modal.Body>
            <div className="py-5 px-2 col-12">
              <div className="row justify-content-center col-12 text-center">

                <div className="col-12">
                  <h3 className="py-4">Upgrade Your Plan to Continue</h3>

                  <p className="mb-5">It looks like you're using a trial account. To proceed, please select a suitable plan.</p>

                  <button type="button" className="btn btn-brand-color col-8 py-2" onClick={() => pageRender("/employer_dashboard/pricing-plan", { replace: true })}>Upgrade now</button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* subscription expired modal  */}
        <Modal
          show={Cookie.get("subscriptionExpired")}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          contentClassName="rounded-4"
        >
          <Modal.Body>
            <div className="py-5 px-2 col-12">
              <div className="row justify-content-center col-12 text-center">
                <div className="col-6 text-center">
                  <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}subscription-expired.png`} alt='subscription expired' with={135} height={135} />
                </div>

                <div className="col-12">
                  <h3 className="py-4">Your current plan has Expired</h3>

                  <p className="mb-5">To continue utilizing our platform effectively, you'll need to upgrade your plan. Upgrading will give you access to all our features and services without interruption.</p>

                  <button type="button" className="btn btn-brand-color col-8 py-2" onClick={() => pageRender("/employer_dashboard/upgrade_plan", { replace: true })}>Upgrade now</button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* assign job modal */}
        <Modal
          show={assignJobModel}
          backdrop="static"
          keyboard={false}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          contentClassName="rounded-4"
          onHide={() => setAssignJobModel(false)}>
          <Modal.Header closeButton>
            <p className='m-0'>Assign Job</p>
          </Modal.Header>
          <Modal.Body className='py-5 '>
            <div className="px-4 col-12">
              <form>
                <div className="mb-3">
                  <label for="assignedJobTitle" className="form-label">Job Title</label>
                  <input type="text" className="form-control" id="assignedJobTitle" value={assignJobModelData?.job_title} readOnly />
                </div>

                <div className="mb-5">
                  <label htmlFor="assigneeSelectBox" className="form-label">Assign to</label>
                  <select id="assigneeSelectBox" className="form-select" aria-label="Default select example" onChange={(e) => setAssignJobModelEditData({ ...assignJobModelEditData, sub_user_id: e.target.value })}>
                    <option value="" selected>{!assignJobModelData?.recruiters?.length ? "No Users Found" : ""}</option>
                    {
                      assignJobModelData?.recruiters?.map((val, ind) => (
                        val?.sub_user_id != Cookie.get("id") ?
                          <option value={val?.sub_user_id}
                            disabled={assignJobModelData?.employer_id === val?.sub_user_id}>
                            {`${val?.first_name} ${val?.full_name} ${assignJobModelData?.employer_id === val?.sub_user_id ? "(Job Assigned)" : ''}`}
                          </option>
                          :
                          null
                      ))
                    }
                  </select>
                  <p className='text-danger mt-2'>{assignJobValidation && !assignJobModelEditData?.sub_user_id ? "Assignee required" : null}</p>
                </div>


                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="flexCheckChecked" onChange={(e) => setAssignJobModelEditData({ ...assignJobModelEditData, confirmation: e.target.checked })} />
                  <label className="form-check-label align-items-center" for="flexCheckChecked">
                    I agree to assign this jobs to the selected user
                  </label>
                </div>
                <p className='text-danger mt-2'>{assignJobValidation && !assignJobModelEditData?.confirmation || assignJobModelEditData?.confirmation === false ? "confirmation required" : null}</p>
              </form>
            </div>
          </Modal.Body>

          <Modal.Footer className='w-100'>
            <div className="col-6 m-0 px-1">
              <button type="button" className='btn btn-outline-secondary w-100' onClick={() => setAssignJobModel(false)}>
                cancel
              </button>
            </div>
            <div className="col-6 m-0 px-1">
              {
                jobAssignSpinner ?
                  <button type="button" className='btn btn-brand-color w-100 pe-none' >
                    <div class="remove-spinner-width spinner-border text-white" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </button>
                  :
                  <button type="button" className='btn btn-brand-color w-100' onClick={handleAssignJob}>
                    Assign
                  </button>
              }
            </div>
          </Modal.Footer>
        </Modal>
      </div >

      {
        Cookie.get("isEmployerFirstVisit") ?
          <Joyride
            callback={handleJoyrideCallback}
            styles={{
              options: {
                width: '500px',
                borderRadius: "60px"
              },
              buttonNext: {
                background: '#e38212',
                outline: 'none'
              },
              buttonSkip: {
                textDecoration: 'underline'
              },
              buttonBack: {
                color: '#212529',
                backgroundColor: '#fff',
                border: " 0px",
                borderRadius: "4px",
                color: "#000",
                cursor: "pointer",
                fontSize: "16px",
                lineHeight: "1",
                padding: "8px",
                appearance: "none",
                outline: "1px solid grey",
              }
            }}
            scrollOffset={300}
            continuous
            disableOverlayClose={true}
            hideCloseButton
            showSkipButton
            showProgress
            steps={steps}
            run={run}
          /> : null
      }
    </>
  )
}

export default EmployerHome